import React, { Component } from "react";
import { t } from 'ttag';

import Services from './services';

class Countdown extends Component {
  state = {
    timerOn: true,
    timerStart: 0,
    timerTime: 0
  };

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.time !== prevProps.time) {
      this.setState({
        timerTime: this.props.time * 60 * 1000
      }, () => {
        this.startTimer();
      })
    }
  }

  startTimer = () => {
    this.setState({
      timerOn: true,
      timerTime: this.state.timerTime,
      timerStart: this.state.timerTime
    });
    this.timer = setInterval(() => {
      const newTime = this.state.timerTime - 1000;
      if (newTime >= 0) {
        this.setState({
          timerTime: newTime
        });
      } else {
        clearInterval(this.timer);
        this.setState({ timerOn: false });
        //localStorage.setItem("redirecturl", this.props.eventId);
        if(this.props.rid === '' || !this.props.rid) {
          window.location.replace(process.env.PUBLIC_URL + '/timeout/' + this.props.eventId);
        } else {
          Services.deleteEvent(this.props.rid, (err, res) => {
            window.location.replace(process.env.PUBLIC_URL + '/timeout/' + this.props.eventId);
          });
        }
      }
    }, 1000);
  };

  stopTimer = () => {
    clearInterval(this.timer);
    this.setState({ timerOn: false });
  };

  resetTimer = () => {
    if (this.state.timerOn === false) {
      this.setState({
        timerTime: this.state.timerStart
      });
    }
  };

  adjustTimer = input => {
    const { timerTime, timerOn } = this.state;
    if (!timerOn) {
      if (input === "incHours" && timerTime + 3600000 < 216000000) {
        this.setState({ timerTime: timerTime + 3600000 });
      } else if (input === "decHours" && timerTime - 3600000 >= 0) {
        this.setState({ timerTime: timerTime - 3600000 });
      } else if (input === "incMinutes" && timerTime + 60000 < 216000000) {
        this.setState({ timerTime: timerTime + 60000 });
      } else if (input === "decMinutes" && timerTime - 60000 >= 0) {
        this.setState({ timerTime: timerTime - 60000 });
      } else if (input === "incSeconds" && timerTime + 1000 < 216000000) {
        this.setState({ timerTime: timerTime + 1000 });
      } else if (input === "decSeconds" && timerTime - 1000 >= 0) {
        this.setState({ timerTime: timerTime - 1000 });
      }
    }
  };

  render() {
    const { timerTime, timerStart, timerOn } = this.state;
    let seconds = ("0" + (Math.floor((timerTime / 1000) % 60) % 60)).slice(-2);
    let minutes = ("0" + Math.floor((timerTime / 60000) % 60)).slice(-2);
    let hours = ("0" + Math.floor((timerTime / 3600000) % 60)).slice(-2);
    // TODO fordítás: Your order will timeout in ...
    return (
      <div className="countdown card" style={{ float: 'right', width: 'auto', padding: 1, margin: 2 }}>
        <div className="countdown-header">{t`Lejárati idő:`}</div>
        <div className="countdown-display">
          <div className="countdown-time">
            {hours} : {minutes} : {seconds}
          </div>
        </div>
      </div>
    );
  }
}

export default Countdown;